import { useEffect, useState } from "react";

export function ReadingProgress() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const el = document.documentElement;
            const total = el.scrollHeight - el.clientHeight;
            setProgress(total > 0 ? (el.scrollTop / total) * 100 : 0);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="fixed top-0 left-0 right-0 z-[60] h-1 bg-transparent" data-testid="reading-progress">
            <div
                className="h-full rounded-full bg-accent-sheen shadow-[0_2px_10px_rgba(108,92,231,0.45)] transition-[width] duration-75 ease-linear"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
}
